// The table header: the title in the page's outline, its description, and the
// page-action cluster, then the consumer region.

import React from 'react'

import { useTable } from '../context'
import { PageActions } from './PageActions'

export const HEADING_LEVELS = [1, 2, 3, 4]

// h2 by default; the consumer sets h1 to h4 to fit the page's outline
export const headingTag = level =>
  `h${HEADING_LEVELS.includes(level) ? level : 2}`

export const Header = () => {
  const { config, refs, titleId, headerActions, slots } = useTable()
  const { ConsumerRegion } = slots
  const Heading = headingTag(config.headingLevel)
  return (
    <>
      <div className="me-table-header">
        <div className="me-table-heading">
          <Heading
            id={titleId}
            ref={refs.title}
            tabIndex={-1}
            className="me-table-title"
          >
            {config.title}
          </Heading>
          {config.description && (
            <p className="me-table-description">{config.description}</p>
          )}
        </div>
        <PageActions actions={headerActions} />
      </div>
      <ConsumerRegion />
    </>
  )
}
